// Cliente de la API del Super Duplicador (Formatos::SuperDuplicatorController).
// Lee la respuesta con tolerancia: si el servidor devuelve HTML (500, sesión vencida) se
// devuelve un error legible en vez de reventar con SyntaxError.
const BASE = "/formatos/super_duplicator";

const token = () => {
    const meta = document.querySelector("[name='csrf-token']");
    return meta ? meta.content : "";
};

async function request(method, path, body) {
    const res = await fetch(`${BASE}${path}`, {
        method,
        headers: { "X-CSRF-Token": token(), "Content-Type": "application/json", "Accept": "application/json" },
        body: body ? JSON.stringify(body) : undefined,
    });
    const text = await res.text();
    let data;
    try {
        data = text ? JSON.parse(text) : {};
    } catch (e) {
        data = { error: res.status === 500 ? "Error del servidor (500). Revisa que las migraciones estén corridas." : `El servidor respondió ${res.status}` };
    }
    if (!res.ok && !data.error) data.error = `El servidor respondió ${res.status}`;
    return { ok: res.ok, status: res.status, ...data };
}

const query = (params) => {
    const q = Object.entries(params || {})
        .filter(([, v]) => v !== undefined && v !== null && v !== "")
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join("&");
    return q ? `?${q}` : "";
};

export const api = {
    tenants: () => request("GET", "/tenants"),
    tree: (tenantId) => request("GET", `/tree/${tenantId}`),
    users: (tenantId) => request("GET", `/users/${tenantId}`),
    plan: (payload) => request("POST", "/plan", payload),
    executions: () => request("GET", "/executions"),
    create: (payload) => request("POST", "/executions", payload),
    execution: (id) => request("GET", `/executions/${id}`),
    logs: (id, params) => request("GET", `/executions/${id}/logs.json${query(params)}`),
    undoPreview: (id, modo, forzar) => request("POST", `/executions/${id}/undo_preview`, { modo, forzar: !!forzar }),
    undo: (id, modo, forzar) => request("POST", `/executions/${id}/undo`, { modo, forzar: !!forzar }),
    repeat: (id, dryRun) => request("POST", `/executions/${id}/repeat`, { dry_run: dryRun }),
    pending: (id) => request("GET", `/executions/${id}/pending`),
    linkPending: (id, payload) => request("POST", `/executions/${id}/link_pending`, payload),
    downloadUrl: (id, ext, params) => `${BASE}/executions/${id}/logs.${ext}${query({ ...(params || {}), download: ext === "json" ? 1 : undefined })}`,
};

export const PHASES = [
    { key: "planear", label: "Planear", icon: "fas fa-route" },
    { key: "preparar", label: "Preparar", icon: "fas fa-cogs" },
    { key: "copiar", label: "Copiar", icon: "fas fa-copy" },
    { key: "verificar", label: "Verificar", icon: "fas fa-check-double" },
    { key: "archivos", label: "Archivos", icon: "fas fa-file-image" },
    { key: "fin", label: "Fin", icon: "fas fa-flag-checkered" },
];

export const STATUS = {
    en_cola: { label: "En cola", tone: "muted", icon: "fas fa-clock" },
    corriendo: { label: "Corriendo", tone: "info", icon: "fas fa-spinner fa-spin" },
    terminada: { label: "Terminada", tone: "ok", icon: "fas fa-check-circle" },
    fallida: { label: "Fallida", tone: "error", icon: "fas fa-times-circle" },
    colgada: { label: "Colgada", tone: "warn", icon: "fas fa-exclamation-triangle" },
};

export const fmtDate = (v) => {
    if (!v) return "—";
    const d = new Date(v);
    return d.toLocaleString("es-CO", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
